/**
 * HTTP 头名大小写不敏感。JS 对象同时有 `website` 与 `Website` 时，
 * fetch / Headers.append 会拼成 `"idn, idn"`。发出前压成一条。
 */

const WEBSITE_LOWER = 'website';

function findHeaderKey(headers: Record<string, string>, name: string): string | undefined {
  const lower = name.toLowerCase();
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === lower) return key;
  }
  return undefined;
}

/** 同名头（大小写不敏感）只留一条，后写覆盖先写；`website` 固定小写键。 */
export function collapseHttpHeaders(headers: Record<string, string> | null | undefined): Record<string, string> {
  const result: Record<string, string> = {};
  const canonicalByLower = new Map<string, string>();
  if (!headers) return result;

  for (const [rawKey, rawValue] of Object.entries(headers)) {
    if (rawValue == null) continue;
    const lower = rawKey.toLowerCase();
    const canonical = lower === WEBSITE_LOWER ? WEBSITE_LOWER : (canonicalByLower.get(lower) ?? rawKey);
    const prev = canonicalByLower.get(lower);
    if (prev && prev !== canonical) delete result[prev];
    canonicalByLower.set(lower, canonical);
    result[canonical] = String(rawValue);
  }
  return result;
}

function resolveLangValue(headers: Record<string, string>, language?: string | null): string {
  const langKey = findHeaderKey(headers, 'lang');
  const languageKey = findHeaderKey(headers, 'language');
  const fromHeader = (langKey && headers[langKey]) || (languageKey && headers[languageKey]) || '';
  const fromOpts = typeof language === 'string' ? language.trim() : '';
  return fromHeader.trim() || fromOpts || 'zh';
}

/** 若还没有 `lang`/`language`，用 `language`（trim），空则 `zh`。已有的键不改。 */
export function applyLangHeaders(headers: Record<string, string>, language?: string | null): Record<string, string> {
  const next = { ...headers };
  const langKey = findHeaderKey(next, 'lang');
  const languageKey = findHeaderKey(next, 'language');
  if (langKey && languageKey) return next;
  const lang = resolveLangValue(next, language);
  if (!langKey) next.lang = lang;
  if (!languageKey) next.language = lang;
  return next;
}

/** collapse 之后补 lang/language。调用方在 fetch / wx.request 之前使用。 */
export function prepareSdkRequestHeaders(
  headers: Record<string, string> | null | undefined,
  language?: string | null,
): Record<string, string> {
  return applyLangHeaders(collapseHttpHeaders(headers), language);
}
